<button :class="classes" :disabled="disabled" v-on="$listeners" type="button">
  <slot></slot>
</button>